'use client';

import React from 'react';
import GlobalTitle from '@shared/GlobalTitle';
import ServiceTab from '@shared/ServiceTab';
import SectionShapes from '@shared/SectionShapes';

export default function ServicesSection({ data }) {
    if (!data) return null;

    return (
        <section className="bg-[#f7f8fc] py-12 md:py-20 overflow-hidden">
            <div className="max-w-[1440px] mx-auto px-6 relative">
                <SectionShapes variant="dark" />

                <div className="text-center mb-8">
                    <GlobalTitle
                        topText={data.topText}
                        titleText={data.titleText}
                        coloredText={data.coloredText}
                        classes=""
                        topTextClass="justify-center"
                    />
                    <p className="text-muted-foreground max-w-6xl mx-auto">
                        {data.description}
                    </p>
                </div>

                <ServiceTab data={data.services} />
            </div>
        </section>
    );
}
